module.exports = __webpack_public_path__ + "static/media/karcher.0fec7372.png";